import { Api } from '@/api';
import { UserLoginType } from '@/DTO';

export const CreateProduct = (
  user: UserLoginType,
  data: {
    author_name: string;
    publisher_id: string;
    amount: number;
    content_id: string[];
    description: string;
    language: string;
    title: string;
    paper_count: number;
    offer: number;
    category_id: string;
    is_auto_price: boolean;
    price: number;
    publish_date: string;
    pricing_id: string;
  },
) => {
  return new Promise<{
    data: any;
  }>((resolve, reject) => {
    const api = new Api({
      method: 'post',
      path: `product/admin`,
      body: JSON.stringify({
        title: data.title,
        description: data.description,
        language: data.language,
        publish_date: data.publish_date,
        author_name: data.author_name,
        paper_count: +data.paper_count,
        offer: +data.offer,
        amount: +data.amount,
        is_auto_price: data.is_auto_price,
        price: data.price,
        pricing_id: data.pricing_id,
        category_id: data.category_id,
        publisher_id: data.publisher_id,
        content_ids: data.content_id,
      }),
      header: {
        Authorization: 'Bearer ' + user.accessToken,
        'Content-Type': 'application/json',
      },
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data,
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};
